import { createRouter, createWebHistory } from "vue-router";
import { loginGuard } from "@shared/router/loginGuard";
import { baseRoutes } from "@shared/baseRoutes";
import { warehouseRoutes } from "@shared/warehouse/routes";
import { assetManagementRoutes } from "@shared/assetManagement/routes";
import { twinModellingRoutes } from "@shared/twinModelling/routes";
import { userManagementRoutes } from "@shared/userManagement/router";
import { ticketManagementRoutes } from "@shared/maintenance/routes";
import { qmdRoutes } from "@shared/qualityManagementDocuments/routes";
import { itAssetManagementRoutes } from "@shared/itAssetManagement/routes";
import { businessPartnersRoutes } from "@shared/businesspartners/routes";
import { knowledgeSpacesRoutes } from "@shared/knowledgeSpaces/routes";
import { processMiningRoutes } from "@shared/processMining/routes";
import { shopFloorWalkRoutes } from "@shared/shopFloorWalk/routes";
import { productsRoutes } from "@shared/products/routes";
import { productComplianceRoutes } from "@shared/productCompliance/routes";

const routes = [
  ...baseRoutes,
  ...warehouseRoutes,
  ...assetManagementRoutes,
  ...twinModellingRoutes,
  ...userManagementRoutes,
  ...ticketManagementRoutes,
  ...qmdRoutes,
  ...itAssetManagementRoutes,
  ...businessPartnersRoutes,
  ...knowledgeSpacesRoutes,
  ...processMiningRoutes,
  ...shopFloorWalkRoutes,
  ...productsRoutes,
  ...productComplianceRoutes,
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/apps-admin/",
    name: "appsAdmin",
    component: () => import("@shared/components/apps/AppsSettings.vue"),
    meta: {
      appClientId: "smx-portal",
      breadcrumbs: [
        {
          label: "appsAdmin",
          route: { name: "appsAdmin" },
        },
      ],
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(loginGuard);

export default router;
